<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">Etiquetas - Proceso {{ processId }} | {{ processDescription }}</p>
    </div>
    <div class="flex justify-end items-center">
        <nz-input-group class="w-[200px] mr-4" [nzPrefix]="searchIcon" [nzSuffix]="clearInput">
            <input onfocus="select()" placeholder="Busca por lote" nz-input [(ngModel)]="searchPackaging"
                (ngModelChange)="onSearch($event)" />
        </nz-input-group>
        <ng-template #clearInput>
            @if (searchPackaging) {
            <span class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="clearFilter()"
                nz-icon></span>
            }
        </ng-template>
        <ng-template #searchIcon>
            <span nz-icon nzType="search"></span>
        </ng-template>
        <button [disabled]="setOfCheckedId.size === 0" (click)="printSelected()" class="button primary-button">
            <span nz-icon nzType="printer"></span>
            Imprimir
        </button>
    </div>
</div>

<div #modalContent class="w-full h-full p-0 m-0">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        @if (stickers && stickers.length > 0) {
        <nz-table #basicTable [nzData]="stickersFiltered" class="m-0 p-0" nzSize="small" [nzLoading]="isLoading"
            nzTableLayout="auto" [nzBordered]="true" [nzFrontPagination]="false" [nzShowPagination]="false"
            [nzScroll]="{ y: (tableHeight || 0) + 'px' }">
            <thead>
                <tr>
                    <th nzWidth="50px" [nzChecked]="checked" [nzIndeterminate]="indeterminate" nzLabel="Seleccionar todas"
                        (nzCheckedChange)="onAllChecked($event)"></th>
                    <th>Tipo formato</th>
                    <th>Lote</th>
                    <th nzWidth="120px">Acciones</th>
                </tr>
            </thead>
            <tbody>
                @for (data of basicTable.data; track data) {
                <tr [id]="'packaging-' + data.id" [class.printed-row]="data.labelPrinted">
                    <td [nzChecked]="setOfCheckedId.has(data.id!)"
                        (nzCheckedChange)="onItemChecked(data.id!, $event)"></td>
                    <td>
                        {{ data.packagingType?.name }}
                        @if (data.labelPrinted) {
                            <span class="printed-tag">YA IMPRESO</span>
                        }
                    </td>
                    <td>{{ getPalletLotValue(data) }}</td>
                    <td>
                        <div class="flex align-middle justify-center">
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Imprimir etiqueta'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="printSticker(data.id!)">
                                <span nz-icon nzType="printer"></span>
                            </button>
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </nz-table>
        }
        @else {
        <div class="w-full h-full content-center">
            <nz-empty></nz-empty>
        </div>
        }
    }
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button (click)="handleCancel()" class="button secondary-button">
            Cerrar
        </button>
    </div>
</div>